import React from "react";

const LatestBlogs = ({data}) => {

  return (
    <div className="latest-blogs">
      <div className="latest-blogs_wrapper">
          <h2>{data.title}</h2>               
          <div className="blog-grid">
            {data?.blogs && data.blogs.map((blog, key) =>
              <div className="blog">
                  <div className="blog-image">
                    { blog.featuredImage != null &&
                      <img src={blog.featuredImage.file.url} alt="" />
                    }
                  </div>
                  <div className="blog-content">
                      <span className="tag">{blog.tags}</span>
                      <a href={`/${blog.slug}`}><h3 className="title">{blog.title}</h3></a>
                      <div className="meta-info"><span className="date">{blog.date}</span><span className="read-time">{blog.readTime} read</span></div>
                      <div className="author-info"><div className="avatar"><img src={blog.byline.graphic.file.url} /></div><span className="name">{blog.byline.title}</span></div>
                  </div>
              </div>
            )}
          </div>
      </div>
    </div>
  )
}

export default LatestBlogs
